import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Inject,
  ViewChild
} from '@angular/core';

import { DropdownSingleComponent } from './components/dropdown-single.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { app_ShellService } from './app.shell.service';
import { app_OperationService } from './app.operation.service';
import { app_DatasourceService } from './app.datasource.index';
import { app_FlowService } from './app.flow.index';
import { app_FrontendFlowService } from './app.frontend.flow.service';
import { app_ReportService } from './app.report.index';
import { app_LocalizationService } from './app.localization.service';
import { app_home_ComponentContextService } from './app.home.component.context.service';
import { Language } from './localization.service';
import { JobStatus, EAssignmentMode } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { $frontendTypes} from './app.frontend.types'
import { $frontendTypes as $types} from './app.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
@Component({
  imports: [
    SharedModule,
  ],
  selector: 'app-home',
  templateUrl: './app.home.component.html'
})
export class app_homeComponent implements OnInit {

  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  //#endregion

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  toolbar = {
  };


  fieldsets = {
  };

  @ViewChild('dd_config') dd_config: DropdownSingleComponent;
  @ViewChild('dd_method') dd_method: DropdownSingleComponent;

  constructor(
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: app_ShellService,
private $datasources: app_DatasourceService,
private $flows: app_FlowService,
private $frontendFlows: app_FrontendFlowService,
private $reports: app_ReportService,
private $localization: app_LocalizationService,
private $operations: app_OperationService,
private $context: app_home_ComponentContextService,
) { 

  }

  ngOnInit(): void {
    this.$init();
  
  }

  initialized = false;

  async $init() {
    this.title = 'Home';
    this.initialized = true;
  }

  close() {
    this.$finish.emit();
  }

  typeValue = null;
  typeList = [
    {
      key: 6,
      name: 'Datasource'
    },
    {
      key: 9,
      name: 'Function'
    }
  ];

  async typeDisplayWithFn(value: any): Promise<string> {
    return this.typeList.find(item => item.key === value)?.name;
  }

  async typeOptionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {
    if (this.$utils.isDefinedTrimmed(filterText)) {
      return { list: this.typeList.filter(item => item.name.startsWith(filterText)), totalCount: this.typeList.length };
    } else {
      return { list: this.typeList, totalCount: this.typeList.length };
    }
  }

  typeValueChange(value) {
    this.typeValue = value;
    this.configValueChange(null);
    this.dd_config.clearListData();
  }


  configValue = null;
  config = null;
  configList = [
    {
      key: 'Get/Adjustment',
      name: 'Get/Adjustment' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'footprint_generic_json_adjustment_export_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'project_lookup_code',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'material_lookup_code',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'render_lots',
            type: 'boolean',
            isCollection: false
          },
          {
            required: false,
            id: 'render_license_plates',
            type: 'boolean',
            isCollection: false
          },
          {
            required: false,
            id: 'render_serial_numbers',
            type: 'boolean',
            isCollection: false
          },
          {
            required: false,
            id: 'integration_name',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'transaction_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'warehouse_name',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'modified_from',
            type: 'date',
            isCollection: false
          },
          {
            required: false,
            id: 'modified_to',
            type: 'date',
            isCollection: false
          },
          {
            required: false,
            id: 'take',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'has_transmissions',
            type: 'boolean',
            isCollection: false
          },
          {
            required: false,
            id: 'output_messages',
            type: 'boolean',
            isCollection: false
          },
          {
            required: false,
            id: 'operation_code',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'Create/Adjustment',
      name: 'Create/Adjustment' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'footprint_generic_json_adjustment_import_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'adjustments',
            type: 'object',
            isCollection: true
          },
          {
            required: false,
            id: 'transaction_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'ingress_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'source_platform',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'submitAsync',
            type: 'boolean',
            isCollection: false
          },
          {
            required: false,
            id: 'integration_name',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'environment',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'sender',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'receiver',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'Get/ImportStatus',
      name: 'Get/ImportStatus' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'footprint_generic_json_check_import_requests',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'request_ids',
            type: 'string',
            isCollection: true
          },
        ]
    },
    {
      key: 'Get/Inventory',
      name: 'Get/Inventory' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'footprint_generic_json_inventory_export_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'project_lookup_code',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'material_lookup_code',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'warehouse_name',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'render_lots',
            type: 'boolean',
            isCollection: false
          },
          {
            required: false,
            id: 'render_license_plates',
            type: 'boolean',
            isCollection: false
          },
          {
            required: false,
            id: 'render_serial_numbers',
            type: 'boolean',
            isCollection: false
          },
          {
            required: false,
            id: 'integration_name',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'transaction_id',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'Get/Invoice',
      name: 'Get/Invoice' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'footprint_generic_json_invoice_export_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'invoice_id',
            type: 'number',
            isCollection: false
          },
          {
            required: false,
            id: 'integration_name',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'transaction_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'invoice_lookup',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'Create/Material',
      name: 'Create/Material' + ' ('+ 'FootprintApiManager' +')',
      referenceName: 'footprint_generic_json_material_import_flow',
      appReferenceName: 'FootprintApiManager',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'materials',
            type: 'object',
            isCollection: true
          },
          {
            required: false,
            id: 'transaction_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'ingress_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'integration_name',
            type: 'string',
            isCollection: false
          },
        ]
    },
    {
      key: 'Create/Order',
      name: 'Create/Order' + ' ('+ 'SPSCommerce' +')',
      referenceName: 'create_order_with_validation',
      appReferenceName: 'SPSCommerce',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'orders',
            type: 'object',
            isCollection: true
          },
        ]
    },
    {
      key: 'Get/CompletedOrders',
      name: 'Get/CompletedOrders' + ' ('+ 'SPSCommerce' +')',
      referenceName: 'get_completed_orders',
      appReferenceName: 'SPSCommerce',
      type: 9,
        inParams: [
          {
            required: true,
            id: 'shipped_date',
            type: 'date',
            isCollection: false
          },
          {
            required: false,
            id: 'order_types',
            type: 'string',
            isCollection: true
          },
          {
            required: false,
            id: 'projects',
            type: 'string',
            isCollection: true
          },
          {
            required: true,
            id: 'has_transmission',
            type: 'boolean',
            isCollection: false
          },
        ]
    },
    {
      key: 'Get/Order',
      name: 'Get/Order' + ' ('+ 'SPSCommerce' +')',
      referenceName: 'get_order_with_options',
      appReferenceName: 'SPSCommerce',
      type: 9,
        inParams: [
          {
            required: false,
            id: 'transaction_id',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'order_lookup',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'project_lookup',
            type: 'string',
            isCollection: false
          },
          {
            required: false,
            id: 'shipment_id',
            type: 'number',
            isCollection: false
          },
          {
            required: true,
            id: 'set_transmission',
            type: 'boolean',
            isCollection: false
          },
        ]
    },
  ];

  async configDisplayWithFn(value: any): Promise<string> {
    return this.configList.find(item => item.key === value)?.name;
  }

  async configOptionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {
    let list = this.configList.filter(item => item.type === this.typeValue);
    const totalCount = list.length;
    if (this.$utils.isDefinedTrimmed(filterText)) {
      list = list.filter(item => item.name.startsWith(filterText));
    }

    return { list, totalCount };
  }
  
  configValueChange(value) {
    this.configValue = value;
    this.config = this.configList.find(item => item.key === value);
    this.methodValueChange(null);
    this.dd_method.clearListData();
  }

  get hasMethods():boolean {
    return this.config && this.config?.methods;
  }
  
  method = null;
  methodValue = null;

  async methodDisplayWithFn(value: any): Promise<string> {
    return value;
  }

  async methodOptionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {
    let list = this.config.methods;
    const totalCount = list.length;
    if (this.$utils.isDefinedTrimmed(filterText)) {
      list = list.filter(item => item.name.startsWith(filterText));
    }

    return { list, totalCount };
  }
  
  methodValueChange(value) {
    this.methodValue = value;
    this.result = null;    
    if (this.hasMethods) {
      this.method = this.config.methods.find(item => item.key === value);
    } else {
      this.method = null;
    }
    this.onInParamChanged();
  }


  get inParams() {
    if (this.config) {
      if (this.config.methods) {
        if (this.method) {
          return this.method.inParams;
        }
      } else {
        return this.config.inParams;
      }
    }
    return null;
  }

  previewInParams = null;
  onInParamChanged() {
    this.previewInParams = {};
    if (this.inParams && this.inParams.length) {
      const inParams: { [key: string]: any } = {};
      this.inParams.forEach(ip => {
        inParams[ip.id] = this.evaluateValue(ip.value);
      });
      this.previewInParams = inParams;
    }
  }

  evaluateValue(value: string) {
    const val = this.$utils.isDefinedTrimmed(value) ? `(${value})` : value;
    const f = new Function(`{ return ${val} }`);
    return f();
  }

  get canExecute (): boolean {
    if (!this.config) {
      return false;
    }
    if (this.config.type === 6 && !this.methodValue) {
      return false;
    } 
    return true;
  }

  result: any;
  async run() {
    if (this.config.type === 6) {
      this.result = await this.$datasources[this.config.appReferenceName][this.config.referenceName][this.methodValue](this.previewInParams);
    } else if (this.config.type === 9) {
      this.result = await this.$flows[this.config.appReferenceName][this.config.referenceName](this.previewInParams);
    }
  }  
}
